module.exports = __webpack_public_path__ + "static/media/logo_horizontal.d18d8a9d.svg";